import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OdlModalDayComponent } from 'src/app/odl-modal-day/odl-modal-day.component';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { DBFirestoreService } from 'src/app/dbfirestore.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { RecursiveCommessa, Autista } from 'src/app/def/structures';
import { Week, EventOrdine, ODLErrorMessages } from 'src/app/def/types';
import { map, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { Router } from '@angular/router';


@Component({
    selector: 'odl-scheduled',
    templateUrl: './scheduled.component.html',
    styleUrls: ['./scheduled.component.scss']
})
export class ScheduledComponent implements OnInit, OnDestroy {

    private unsubscribe$ = new Subject<void>();

    selected_week$: BehaviorSubject<Week | null>;
    // commesse$: Observable<RecursiveCommesse[]>;
    commesse: RecursiveCommessa[];

    private updated_modal_day$ = new Subject<{ ordine: any; commessa: any }>();

    loading = true;
    faUnconfirmed = faEdit;

    printCommesse = true;
    printRapportino = false;
    rapportino_vars = {
        ordine: null,
        commessa: null,
    };
    rapportino_modello = '';


    ascending: { [key: string]: boolean } = {};

    constructor(
        private modalService: NgbModal,
        private db: DBFirestoreService,
        private router: Router,
    ) {
        this.selected_week$ = new BehaviorSubject(null);
    }

    ngOnInit() {

        this.selected_week$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((week: Week | null) => {
                if (week) {
                    this.setCommesse(week);
                }
            });

        this.updated_modal_day$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => {
                this.rapportino_vars = { ordine: data.ordine, commessa: data.commessa };
            });
    }

    sortByWeek() {
        this.ascending.settimana = false;    // Forziamo l'unico ordinamento disponibile ora come crescente

        const key = 'settimana';
        this.ascending[key] = !!!this.ascending[key];
        this.commesse = this.commesse.sort((a, b) => {
            const na = a.ordini.filter(item => item !== null && item !== undefined);
            const nb = b.ordini.filter(item => item !== null && item !== undefined);
            if (this.ascending[key]) {
                return (na[0].giorno_ora < nb[0].giorno_ora ? -1 : 1);
            } else {
                return (na[na.length - 1].giorno_ora < nb[nb.length - 1].giorno_ora ? 1 : -1);
            }
        });

        localStorage.setItem('last_sort', JSON.stringify({ type: 'byweek', key: key, order: this.ascending[key] }));
    }

    setCommesse(week: Week) {
        this.loading = true;
        // const test_date1 = new Date(2019,8,30,0,0,0);
        // const test_date2 = new Date(2019,9,6,23,59,59);
        // console.log(week[0].getFullYear(), week[0].getMonth(), week[0].getDate(), week[0].getHours(), week[0].getMinutes(), week[0].getSeconds());
        // console.log(week[1].getFullYear(), week[1].getMonth(), week[1].getDate(), week[1].getHours(), week[1].getMinutes(), week[1].getSeconds());
        const date1 = new Date(week[0].getFullYear(), week[0].getMonth(), week[0].getDate(), week[0].getHours(), week[0].getMinutes(), week[0].getSeconds());
        const date2 = new Date(week[1].getFullYear(), week[1].getMonth(), week[1].getDate(), week[1].getHours(), week[1].getMinutes(), week[1].getSeconds());

        this.db.getRecursiveCommesse(date1, date2).pipe(
            map(commesse => {

                return commesse.map(commessa => {

                    const newOrdini = [
                        null, // Lun,
                        null, // mar,
                        null, // mer,
                        null, // gio,
                        null, // ven,
                        null, // sab,
                        null, // dom,
                    ];

                    commessa.ordini.map(ordine => {
                        const giorno = moment(ordine.giorno_ora);
                        if (giorno.day() === 0) {
                            newOrdini[6] = ordine;
                        } else {
                            newOrdini[giorno.day() - 1] = ordine;
                        }

                    });

                    commessa.ordini = newOrdini;

                    return commessa;
                });
            }),
            takeUntil(this.unsubscribe$)
        ).subscribe(results => {
            this.commesse = results;
            this.sortByWeek();
            this.loading = false;
        });
    }

    siglaCapoSquadra(capo: Autista) {
        return capo ? capo.cognome.charAt(0) + capo.nome.charAt(0) : '';
    }

    onDayClick(day, commessa) {
        if (day) {
            this.apriOrdineDelGiorno({ commessa, ordine: day });
        } else {
            this.rapportino_vars = { ordine: false, commessa: false };
        }

    }

    apriOrdineDelGiorno(data: any = null, params: any = {}) {

        const odlModalDay = this.modalService.open(OdlModalDayComponent, { size: <any>'xl', windowClass: 'modal-xxl' });
        odlModalDay.result.then((response: EventOrdine) => {
            if (response.type === 'edit') {
                this.db.updateOrdine(response.data).then(success => {
                }).catch(error => {
                    this.onError({ title: 'Errore aggiornamento', details: error });
                });
            }
            if (response.type === 'delete') {

                this.db.deleteOrdine({ id: response.id, rif_commessa: response.parent_id }).then(success => {
                    this.db.getRecursiveCommessaById(response.parent_id)
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe(found => {
                            if (!found.ordini.length) {
                                this.db.deleteCommessa({ id: response.parent_id }).then(() => {

                                }).catch(error => {
                                    this.onError({ title: 'Errore cancellazione ordine', details: error });
                                });
                            }
                        });
                }).catch(error => {
                    this.onError({ title: 'Errore cancellazione intervento', details: error });
                });
            }
            this.printCommesse = true;
            this.printRapportino = false;
            this.rapportino_vars = { ordine: false, commessa: false };
            this.rapportino_modello = '';
        }, reject => {
            // console.log('Reject', reject);
            // Modal chiuso
            this.printCommesse = true;
            this.printRapportino = false;
            this.rapportino_vars = { ordine: false, commessa: false };
            this.rapportino_modello = '';
        });
        data.updated_observable = this.updated_modal_day$;
        odlModalDay.componentInstance.setData(data);

        this.printCommesse = false;
        this.printRapportino = true;
        this.rapportino_vars = { ordine: data.ordine, commessa: data.commessa };
        // this.rapportino_modello = 'mod4e' ;
        this.rapportino_modello = data && data.commessa && data.commessa.tipo_intervento ? data.commessa.tipo_intervento.modello : '';
        // console.log(this.rapportino_vars);
    }

    onWeekChange(week: Week) {
        this.selected_week$.next(week);
    }

    onError(error: ODLErrorMessages) {
        alert(error.title);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
